import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IPlaybackStream } from '@obvious.tech/constellation'

export const PlaybackStream = defineEntity('PlaybackStream', {
  endpoint: 'videomanager/api/PlaybackStream',
  schema: SNoop<IPlaybackStream>(),
})
